export default {
    components: {
    },
    model: {
        prop: 'text',
        event: 'change'
    },
    props: ['text', 'line', 'maxHeight'],
    data () {
        return {
            height: 104
        }
    },
    watch: {
    },
    mounted () {
        if (this.maxHeight) {
            this.height = this.maxHeight
        }
        this.init()
    },
    methods: {
        init() {
            if (this.text) {
                this.$refs.text.innerHTML = this.text.join("\n")
            }
        },
        textChange() {
            let text = this.$refs.text.value
            let values = text.split("\n")
            values = values.filter(value => {
                value = value.replace(/<[^>]+>/g, '')
                return value.replace(/\s*/g, '') !== ''
            })
            this.$emit('change', values)
        }
    }
}
